import React from 'react'
import classNames from 'classnames'
import css from './Flower.styles.scss'
import { ShapeProps } from '../../FloatingShapesBackground.types'

const Flower: React.FC<ShapeProps> = ({ animated }) => (
  <svg
    className={classNames(css.Flower, {
      [css.Flower__Animated]: animated,
    })}
    fill="none"
    height="136"
    id="flower"
    viewBox="0 0 190 180"
    width="144"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M153.527 30.9897C153.793 40.299 150.003 48.7912 143.744 54.8041C147.6 53.021 151.878 51.9585 156.405 51.7994C174.326 51.1694 189.358 64.9341 189.98 82.5437C190.602 100.153 176.579 114.939 158.658 115.569C155.581 115.678 152.589 115.361 149.741 114.674C159.001 120.096 165.309 129.984 165.572 141.418C165.978 159.033 151.883 173.645 134.088 174.053C118.681 174.406 105.552 163.995 102.044 149.76C101.294 166.183 87.7443 179.504 70.753 179.986C52.9613 180.492 38.1333 166.731 37.6339 149.25C37.3416 139.018 42.0233 129.779 49.5243 123.775C44.879 126.603 39.4446 128.317 33.5949 128.523C15.6742 129.153 0.642188 115.388 0.0199331 97.7787C-0.602322 80.1691 13.4209 65.383 31.3415 64.753C34.6448 64.6369 37.8498 65.0098 40.8846 65.8058C31.6589 60.4191 25.3801 50.6239 25.119 39.3016C24.7159 21.8181 38.8142 7.31412 56.6085 6.90593C72.806 6.53436 86.4826 17.9704 89.1108 33.2124C89.1055 33.0821 89.101 32.9515 89.0973 32.8208C88.5941 15.2074 102.609 0.51906 120.401 0.0133996C138.193 -0.492261 153.024 13.3763 153.527 30.9897Z"
      fill="url(#paint0_linear_4569_48393)"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M153.527 30.9897C153.793 40.299 150.003 48.7912 143.744 54.8041C147.6 53.021 151.878 51.9585 156.405 51.7994C174.326 51.1694 189.358 64.9341 189.98 82.5437C190.602 100.153 176.579 114.939 158.658 115.569C155.581 115.678 152.589 115.361 149.741 114.674C159.001 120.096 165.309 129.984 165.572 141.418C165.978 159.033 151.883 173.645 134.088 174.053C118.681 174.406 105.552 163.995 102.044 149.76C101.294 166.183 87.7443 179.504 70.753 179.986C52.9613 180.492 38.1333 166.731 37.6339 149.25C37.3416 139.018 42.0233 129.779 49.5243 123.775C44.879 126.603 39.4446 128.317 33.5949 128.523C15.6742 129.153 0.642188 115.388 0.0199331 97.7787C-0.602322 80.1691 13.4209 65.383 31.3415 64.753C34.6448 64.6369 37.8498 65.0098 40.8846 65.8058C31.6589 60.4191 25.3801 50.6239 25.119 39.3016C24.7159 21.8181 38.8142 7.31412 56.6085 6.90593C72.806 6.53436 86.4826 17.9704 89.1108 33.2124C89.1055 33.0821 89.101 32.9515 89.0973 32.8208C88.5941 15.2074 102.609 0.51906 120.401 0.0133996C138.193 -0.492261 153.024 13.3763 153.527 30.9897Z"
      fill="url(#paint1_radial_4569_48393)"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M153.527 30.9897C153.793 40.299 150.003 48.7912 143.744 54.8041C147.6 53.021 151.878 51.9585 156.405 51.7994C174.326 51.1694 189.358 64.9341 189.98 82.5437C190.602 100.153 176.579 114.939 158.658 115.569C155.581 115.678 152.589 115.361 149.741 114.674C159.001 120.096 165.309 129.984 165.572 141.418C165.978 159.033 151.883 173.645 134.088 174.053C118.681 174.406 105.552 163.995 102.044 149.76C101.294 166.183 87.7443 179.504 70.753 179.986C52.9613 180.492 38.1333 166.731 37.6339 149.25C37.3416 139.018 42.0233 129.779 49.5243 123.775C44.879 126.603 39.4446 128.317 33.5949 128.523C15.6742 129.153 0.642188 115.388 0.0199331 97.7787C-0.602322 80.1691 13.4209 65.383 31.3415 64.753C34.6448 64.6369 37.8498 65.0098 40.8846 65.8058C31.6589 60.4191 25.3801 50.6239 25.119 39.3016C24.7159 21.8181 38.8142 7.31412 56.6085 6.90593C72.806 6.53436 86.4826 17.9704 89.1108 33.2124C89.1055 33.0821 89.101 32.9515 89.0973 32.8208C88.5941 15.2074 102.609 0.51906 120.401 0.0133996C138.193 -0.492261 153.024 13.3763 153.527 30.9897Z"
      fill="url(#paint2_linear_4569_48393)"
      fillOpacity="0.5"
      fillRule="evenodd"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_4569_48393"
        x1="0"
        x2="189.801"
        y1="90"
        y2="-0.418804"
      >
        <stop stopColor="#A0DCFF" />
        <stop offset="1" stopColor="#6E3264" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(190 90) rotate(-180) scale(190 200.556)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_4569_48393"
        r="1"
      >
        <stop stopColor="#E08DCA" />
        <stop offset="0.754526" stopColor="#E08DCA" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_4569_48393"
        x1="95"
        x2="95"
        y1="89.9998"
        y2="180"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
)

export default Flower
